import { useState } from "react";
import { LibraryBig, CalendarDays, ListMusic, Package, Users, Music2, ChevronLeft, ChevronRight, FolderOpen, Heart, Settings } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

const BASE_SLIDES = [
  { icon: Music2, title: "tut.s1_title", desc: "tut.s1_desc" },
  { icon: LibraryBig, title: "tut.s2_title", desc: "tut.s2_desc" },
  { icon: CalendarDays, title: "tut.s3_title", desc: "tut.s3_desc" },
  { icon: ListMusic, title: "tut.s4_title", desc: "tut.s4_desc" },
  { icon: Package, title: "tut.s5_title", desc: "tut.s5_desc" },
];
const ADMIN_SLIDE = { icon: Users, title: "tut.s6_title", desc: "tut.s6_desc" };
// Espace personnel : uniquement les onglets réellement disponibles
const PERSONAL_SLIDES = [
  { icon: LibraryBig, title: "tut.p1_title", desc: "tut.p1_desc" },
  { icon: FolderOpen, title: "tut.p2_title", desc: "tut.p2_desc" },
  { icon: Heart, title: "tut.p3_title", desc: "tut.p3_desc" },
  { icon: Settings, title: "tut.p4_title", desc: "tut.p4_desc" },
];

// Carrousel de découverte : affiché au premier lancement, rejouable depuis Paramètres > Profil
export default function TutorialCarousel({ onClose }) {
  const { user, group, t } = useAuth();
  const slides = group?.kind === "personal" ? PERSONAL_SLIDES : user?.role === "admin" ? [...BASE_SLIDES, ADMIN_SLIDE] : BASE_SLIDES;
  const [idx, setIdx] = useState(0);
  const slide = slides[idx];
  const Icon = slide.icon;
  const last = idx === slides.length - 1;

  return (
    <div className="fixed inset-0 z-[70] app-bg flex flex-col items-center justify-center p-6 anim-fade-up" data-testid="tutorial-overlay">
      <button onClick={onClose} className="absolute top-5 right-5 text-xs t-secondary hover:text-white transition-colors" data-testid="tutorial-skip">
        {t("tut.skip")}
      </button>

      <div key={idx} className="flex flex-col items-center text-center max-w-md anim-fade-up" data-testid="tutorial-slide">
        <span className="h-24 w-24 rounded-3xl brand-bg/15 brand flex items-center justify-center mb-8 border border-app" data-testid="tutorial-slide-icon">
          <Icon className="h-11 w-11" />
        </span>
        <h2 className="font-heading text-2xl lg:text-3xl font-extrabold mb-3" data-testid="tutorial-slide-title">{t(slide.title)}</h2>
        <p className="t-secondary text-sm lg:text-base leading-relaxed" data-testid="tutorial-slide-desc">{t(slide.desc)}</p>
      </div>

      <div className="flex items-center gap-2 mt-10" data-testid="tutorial-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setIdx(i)}
            aria-label={t("tut.counter", { i: i + 1, n: slides.length })}
            className={`h-2 rounded-full transition-all ${i === idx ? "w-6 accent-bg" : "w-2 bg-white/20 hover:bg-white/40"}`}
            data-testid={`tutorial-dot-${i}`}
          />
        ))}
      </div>

      <div className="flex items-center gap-3 mt-8 w-full max-w-md">
        {idx > 0 && (
          <Button variant="outline" className="border-app" onClick={() => setIdx(idx - 1)} data-testid="tutorial-prev">
            <ChevronLeft className="h-4 w-4" />
          </Button>
        )}
        <Button className="flex-1 brand-bg text-white font-bold h-12 rounded-xl" onClick={() => (last ? onClose() : setIdx(idx + 1))} data-testid="tutorial-next">
          {last ? t("tut.start") : t("tut.next")}
          {!last && <ChevronRight className="h-4 w-4 ml-1" />}
        </Button>
      </div>
    </div>
  );
}
